var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 103,
    viewBox: "0 0 100 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5195 74.3701L36.5754 102.533H70.3433L53.2874 74.3701H19.5195Z",
    fill: "#003563"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4819 28.1625L63.4261 0H29.6582L46.7141 28.1625H80.4819Z",
    fill: "#003563"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7128 28.1625L19.5193 74.3706C4.37011 74.3706 -4.9757 57.8566 2.79685 44.8641L29.657 0L46.7128 28.1625Z",
    fill: "url(#paint0_linear_3717_15765)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4819 28.1625L63.4261 0H29.6582L46.7141 28.1625H80.4819Z",
    fill: "#003563"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7128 28.1625L19.5193 74.3706C4.37011 74.3706 -4.9757 57.8566 2.79685 44.8641L29.657 0L46.7128 28.1625Z",
    fill: "url(#paint1_linear_3717_15765)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2871 74.3712L80.4806 28.1631C95.6298 28.1631 104.976 44.6772 97.2031 57.6696L70.343 102.534L53.2871 74.3712V74.3712Z",
    fill: "url(#paint2_linear_3717_15765)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4809 28.1631L53.2874 74.3712H19.5195L46.713 28.1631H80.4809Z",
    fill: "url(#paint3_linear_3717_15765)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3717_15765",
    x1: 39.0236,
    y1: 14.7116,
    x2: 10.1943,
    y2: 59.5653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2968A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#003366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3717_15765",
    x1: 39.0236,
    y1: 14.7116,
    x2: 10.1943,
    y2: 59.5653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2968A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#003366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3717_15765",
    x1: 60.9659,
    y1: 87.8221,
    x2: 89.7848,
    y2: 42.9684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2968A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#003366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3717_15765",
    x1: 49.995,
    y1: 74.3712,
    x2: 49.995,
    y2: 28.1631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#BCAA33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D9B933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EEC333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FAC933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFCC33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FAC933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EEC333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#D9B933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#BCAA33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999933"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBi);
export default __webpack_public_path__ + "static/media/BI.586e20f699c5400155a48f5793ae375d.svg";
export { ForwardRef as ReactComponent };